import React, { useCallback, useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { Pagination } from "../../../utils/Pagination";
import { fetchCourseStatus } from "../../../services/coures/fetchCourseStatus";
import { SmartFilterBar } from "../../../components/common/SmartFilterBar";
import { useLocation, useNavigate } from "react-router-dom";
import { IoInformationOutline } from "react-icons/io5";
import { ViewCourse } from "./ViewCourse";

export const CoursePricing = () => {
  const { BeURL } = useContext(DContext);

  const navigate = useNavigate()
const [activeTab, setActiveTab] = useState("all");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const loaction = useLocation()

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  const [filters, setFilters] = useState({});

  const [selectedCourse, setSelectedCourse] = useState(null);

  const [price, setPrice] = useState("");
  const [discount, setDiscount] = useState("");
  const [discountType, setDiscountType] = useState("percent");

  const [discountStartDate, setDiscountStartDate] = useState("");
  const [discountEndDate, setDiscountEndDate] = useState("");

  const [mode, setMode] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [rejectReason, setRejectReason] = useState("");

  const [saving, setSaving] = useState(false);

  const today = new Date().toISOString().split("T")[0];

  /* ================= CALCULATION ================= */
  const discountValue =
    discountType === "percent"
      ? ((Number(price) || 0) * (Number(discount) || 0)) / 100
      : Number(discount) || 0;

  const finalPrice = Math.max(0, (Number(price) || 0) - discountValue);

  /* ================= VALIDATION ================= */
  const isPriceInvalid =
    actionType === "approve" && (!price || Number(price) <= 0);

  const isDiscountInvalid =
    discountType === "percent" &&
    (Number(discount) < 0 || Number(discount) > 100);

  const isStartDateInvalid = discountStartDate && discountStartDate < today;

  const isEndDateInvalid =
    discountStartDate &&
    discountEndDate &&
    discountEndDate < discountStartDate;

  const isRejectInvalid =
    actionType === "reject" && !rejectReason.trim();

  const isFormInvalid =
    isPriceInvalid ||
    isDiscountInvalid ||
    isStartDateInvalid ||
    isEndDateInvalid ||
    isRejectInvalid ||
    (!actionType && mode !== "update");

  /* ================= LOAD DATA ================= */

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchCourseStatus({
        BeURL,
        type: "all",
        page,
        limit,
        ...filters
      });

      if (res?.success) {
        setCourses(res.courses || []);
        setTotalPages(res.totalPages || 1);
        setTotal(res.total || 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  },[BeURL,page,limit,filters]);



  useEffect(() => {
    loadData();
  }, [loadData]);


  useEffect(() => {
    if (loaction?.state?.course) {
      setSelectedCourse(loaction?.state?.course);
    }
  }, [loaction?.state?.course]);

  /* ================= MODAL ================= */
  const openModal = (course) => {
    setSelectedCourse(course);

    // const lastStatus =
    //   course.status?.length > 0
    //     ? course.status[course.status.length - 1].stage
    //     : "draft";

    setPrice(course.price ?? "");
    setDiscount(course.discountPercent ?? "");
    setDiscountStartDate(course.discountStartDate ?? "");
    setDiscountEndDate(course.discountEndDate ?? "");
    setRejectReason("");
    setActionType(null);
    setDiscountType("percent");
  };

  const closeModal = () => {
    setSelectedCourse(null);
    setMode(null);
    setActionType(null);
    setRejectReason("");
    setPrice("");
    setDiscount("");
    setDiscountStartDate("");
    setDiscountEndDate("");
  };

  /* ================= API ================= */
  const updatePricing = async (type) => {
    if (isFormInvalid) return;

    try {
      setSaving(true);

      await fetch(`${BeURL}/course/pricing/${selectedCourse._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          price: Number(price),

          discountPercent:
            discountType === "percent"
              ? Number(discount) || 0
              : ((Number(discount) || 0) /
                (Number(price) || 1)) *
              100,

          stage:
            actionType === "approve"
              ? "approved"
              : actionType === "reject"
                ? "rejected"
                : null,
          rejectReason:
            actionType === "reject" ? rejectReason : null,
        }),
      });

      closeModal();
      loadData();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };




  const handleCourse = (courseId) => {
    navigate("/app/course-view", {
      state: { courseId }
    });
  };

  /* ================= UI ================= */
  return (
    <div className="p-8 space-y-6 bg-gray-50 min-h-screen">

      <div className="flex justify-between items-center">

   
  
            <h2 className="text-2xl font-bold">Pricing & Monetization</h2>

          <span className="bg-primary-100 text-primary-700 text-xs px-3 py-1 rounded-full">
            Total: {total}
          </span>
    

      </div>


      <SmartFilterBar
        BeURL={BeURL}
        onChange={(f) => {
          setFilters(f);
          setPage(1);
        }}
      />

      <div className="flex gap-6 border-b">
        {["all", "pending", "approved", "rejected", "draft"].map(tab => (

          <button
            key={tab}
            onClick={() => {
              setActiveTab(tab);
              setPage(1);
            }}
            className={`pb-2 border-b-2 capitalize ${activeTab === tab
              ? "border-primary-600 text-primary-600"
              : "border-transparent"}`}
          >
            {tab}
          </button>

        ))}

      </div>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="bg-white rounded-xl shadow overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-primary-100 text-xs uppercase text-primary-600 sticky top-0 z-50">
              <tr className="text-center">
                <th className="p-3 whitespace-nowrap border text-center">Sl.No</th>
                <th className="p-3 whitespace-nowrap border text-center">Course Code</th>
                <th className="p-3 whitespace-nowrap border text-center">Course</th>
                <th className="p-3 whitespace-nowrap border text-center">Instructor</th>
                <th className="p-3 whitespace-nowrap border text-center">Status</th>
                <th className="p-3 whitespace-nowrap border text-center">Base Price</th>
                <th className="p-3 whitespace-nowrap border text-center">Discount</th>
                <th className="p-3 whitespace-nowrap border text-center">Final Price</th>
                  <th className="p-3 whitespace-nowrap border text-center flex items-center justify-center gap-2">
                    Action
                    <span
                      title="Price cannot be updated for draft courses. Only Pending, Approved, or Rejected courses can be updated."
                      className="bg-black text-white text-xs w-5 h-5 flex items-center justify-center rounded-full cursor-pointer"
                    >
                      <IoInformationOutline />
                    </span>
                  </th>
              </tr>
            </thead>

            <tbody>
              {courses.map((course, idx) => {
                const lastStatus =
                  course.status?.length > 0
                    ? course.status[
                      course.status.length - 1
                    ].stage
                    : "draft";

                return (
                  <tr
                    key={idx}
                    className="border-t hover:bg-gray-50"
                  >
                    <td className="p-3 whitespace-nowrap border text-center">
                      {idx + 1}
                    </td>
                    <td className="p-3 whitespace-nowrap border text-center">
                      {course?.code || "-"}
                    </td>
                    <td onClick={() => handleCourse(course?._id)} className="p-3 whitespace-nowrap border font-semibold text-primary-600 hover:underline">
                      {course.title}
                    </td>
                    <td className="p-3 whitespace-nowrap border text-center">
                      {course.createdBy?.fullName || "-"}
                    </td>
                    <td className="p-3 whitespace-nowrap border capitalize">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${lastStatus === "approved"
                          ? "bg-green-100 text-green-600"
                          : lastStatus === "pending"
                            ? "bg-yellow-100 text-yellow-600"
                            : lastStatus === "rejected"
                              ? "bg-red-100 text-red-600"
                              : "bg-gray-100 text-gray-600"
                          }`}
                      >
                        {lastStatus}
                      </span>
                    </td>
                    <td className="p-3 whitespace-nowrap border">
                      ₹<span className="font-bold">{course.price ?? 0}</span>
                    </td>
                    <td className="p-3 whitespace-nowrap border">
                      %<span className="font-bold">{course.discountPercent.toFixed(2) ?? 0} </span>
                    </td>
                    <td className="p-3 whitespace-nowrap border">
                      ₹{course?.finalPrice || course.price || 0}
                    </td>
                    {/* <td className="p-3 whitespace-nowrap border">
                      {course?.discountStartDate
                        ? new Date(course.discountStartDate).toLocaleDateString()
                        : "-"}
                    </td>

                    <td className="p-3 whitespace-nowrap border">
                      {course?.discountEndDate
                        ? new Date(course.discountEndDate).toLocaleDateString()
                        : "-"}
                    </td> */}
                    <td className="p-3 whitespace-nowrap border">
                      <button
                        title={
                          lastStatus === "draft"
                            ? "Price cannot be updated while the instructor is editing the course. Submit the course for review to enable price changes."
                            : ""
                        }
                        disabled={lastStatus === "draft"}
                        onClick={() => openModal(course)}
                        className={`px-4 py-1.5 rounded-lg text-white
                        ${lastStatus === "draft"
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-secondary-600 hover:bg-secondary-700"
                          }`}
                      >
                       Take Action
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <Pagination
        page={page}
        totalPages={totalPages}
        limit={limit}
        totalUsers={total}
        setPage={setPage}
        setLimit={setLimit}
      />

      {/* ================= MODAL ================= */}
      {selectedCourse && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="relative bg-white rounded-2xl p-6 w-[420px] max-w-[95%] space-y-4 shadow-2xl">

            <div className="flex justify-between items-center">

              <div className="flex items-center gap-2">
                <p className="text-xl font-semibold">Update Price</p>

                {/* INFO BUTTON */}
                <button
                  title="If approved, the price will be updated. If rejected, a reason is required."
                  className="bg-black text-white text-xs px-2 py-1 rounded-full cursor-pointer"
                >
                  <IoInformationOutline />
                </button>
              </div>

              {/* CLOSE BUTTON */}
              <button
                onClick={closeModal}
                className="text-gray-500"
              >
                ✕
              </button>

            </div>

            <h3 className="text-lg">
            Course : {selectedCourse.title}
            </h3>

            <div className="flex bg-gray-100 rounded-xl p-1">
              <button
                onClick={() => setActionType("approve")}
                className={`flex-1 py-2 rounded-lg transition ${actionType === "approve"
                    ? "bg-green-500 text-white shadow"
                    : "text-gray-600"
                  }`}
              >
                Approve
              </button>

              <button
                onClick={() => setActionType("reject")}
                className={`flex-1 py-2 rounded-lg transition ${actionType === "reject"
                    ? "bg-red-500 text-white shadow"
                    : "text-gray-600"
                  }`}
              >
                Reject
              </button>
            </div>


            {(actionType === "approve") && (
              <>
                <div>
                  <label>Price:</label>
                  <input
                    type="number"
                    placeholder="Price"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                <div className="flex gap-2">
                  <div>
                    <label>Discount Type:</label>
                    <select
                      value={discountType}
                      onChange={(e) =>
                        setDiscountType(e.target.value)
                      }
                      className="border rounded-lg px-3 py-2"
                    >
                      <option value="percent">%Percent</option>
                      <option value="amount">₹Amount</option>
                    </select>
                  </div>

                  <div>
                    <label>Discount:</label>
                    <input
                      type="number"
                      placeholder="Discount"
                      value={discount}
                      onChange={(e) =>
                        setDiscount(e.target.value)
                      }
                      className="w-full border rounded-lg px-3 py-2"
                    />
                  </div>

                </div>
                {/* <div>
                  <label>Discount Start Date:</label>
                  <input
                    type="date"
                    min={today}
                    value={discountStartDate}
                    onChange={(e) =>
                      setDiscountStartDate(e.target.value)
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                <div>
                  <label>Discount End Date:</label>
                  <input
                    type="date"
                    min={discountStartDate || today}
                    value={discountEndDate}
                    onChange={(e) =>
                      setDiscountEndDate(e.target.value)
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div> */}


              </>
            )}

            {actionType === "reject" && (
              <textarea
                placeholder="Reject Reason"
                value={rejectReason}
                onChange={(e) =>
                  setRejectReason(e.target.value)
                }
                className="w-full border rounded-lg px-3 py-2"
              />
            )}

            {/* ===== PRICE CALC BOX ===== */}
            {actionType === "approve" && (
              <div className="bg-gray-50 border rounded-xl p-4 space-y-2">
                <div className="flex justify-between text-sm">
                  <span>Base Price</span>
                  <span>₹{price || 0}</span>
                </div>

                <div className="flex justify-between text-sm text-red-500">
                  <span>Discount</span>
                  <span>-₹{discountValue.toFixed(2)}</span>
                </div>

                <div className="border-t pt-2 flex justify-between font-bold text-primary-600">
                  <span>Final Price</span>
                  <span>₹{finalPrice.toFixed(2)}</span>
                </div>
              </div>
            )}

            <div className="flex justify-end gap-3 pt-4">
              <button
                onClick={closeModal}
                className="px-4 py-2 border rounded-lg"
              >
                Cancel
              </button>

              <button
                onClick={() => updatePricing(actionType)}
                disabled={saving || isFormInvalid}
                className={`px-4 py-2 text-white rounded-lg ${saving || isFormInvalid
                  ? "bg-gray-300"
                  : "bg-primary-600 hover:bg-primary-700"
                  }`}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};